import PublicLayout from "@/components/PublicLayout";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Cog } from "lucide-react";

export function CapabilitiesPage() {
  const [caps, setCaps] = useState([]);
  useEffect(() => {
    api.get("/reference/capabilities").then((r) => setCaps(r.data.capabilities || []));
  }, []);
  return (
    <PublicLayout>
      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-xs font-bold tracking-widest text-brand-amber mb-3">قدراتنا</div>
          <h1 className="text-4xl font-bold text-brand-navy mb-4">القدرات التصنيعية</h1>
          <p className="text-slate-600 leading-relaxed text-lg max-w-3xl">
            شبكة MERQAV تشمل ورشاً متخصصة في مختلف عمليات التصنيع الميكانيكي والمعدني والبلاستيكي والمطاطي والمعالجات السطحية.
          </p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {caps.map((c) => (
              <div key={c.key} className="card-industrial p-5" data-testid={`capability-card-${c.key}`}>
                <div className="w-10 h-10 rounded-md bg-brand-amber/10 flex items-center justify-center mb-3">
                  <Cog className="w-5 h-5 text-brand-amber" />
                </div>
                <div className="font-semibold text-brand-navy">{c.label_ar}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}

export function IndustriesPage() {
  const [inds, setInds] = useState([]);
  useEffect(() => {
    api.get("/reference/industries").then((r) => setInds(r.data.industries || []));
  }, []);
  return (
    <PublicLayout>
      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-xs font-bold tracking-widest text-brand-amber mb-3">القطاعات</div>
          <h1 className="text-4xl font-bold text-brand-navy mb-4">القطاعات التي نخدمها</h1>
          <p className="text-slate-600 leading-relaxed text-lg max-w-3xl">
            نخدم أهم القطاعات الصناعية في المملكة، من المصانع الغذائية إلى المعدات الثقيلة والطاقة والبنية التحتية.
          </p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
            {inds.map((i) => (
              <div key={i.key} className="card-industrial p-6" data-testid={`industry-card-${i.key}`}>
                <div className="text-lg font-semibold text-brand-navy">{i.label_ar}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
